import { Deduction } from "@/core/entities/deduction";
import { Division } from "@ir/ui";
import classNames from "classnames";
import { forwardRef } from "react";

interface ClickableTableCellProps {
  record: Deduction;
  onRowSelect: (record: Deduction) => void | Promise<void>;
  isEnabled: boolean;
  cellClassName: string;
  children: React.ReactNode;
  style?: React.CSSProperties;
}

const ClickableTableCell = forwardRef<HTMLDivElement, ClickableTableCellProps>(
  ({ children, record, onRowSelect, isEnabled, cellClassName, style }, ref) => {
    return (
      <Division
        ref={ref}
        className={classNames(cellClassName, {
          [`${cellClassName}-disabled`]: !isEnabled,
        })}
        style={style}
        onClick={() => (isEnabled ? Promise.resolve(onRowSelect(record)).catch(() => {}) : undefined)}
        role="button"
        tabIndex={0}
        onKeyDown={(e: React.KeyboardEvent<HTMLDivElement>) => {
          if (!isEnabled) {
            return;
          }
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            Promise.resolve(onRowSelect(record)).catch(() => {});
          }
        }}
      >
        {children}
      </Division>
    );
  }
);

ClickableTableCell.displayName = "ClickableTableCell";

export default ClickableTableCell;
